<template>
    <v-layout class="set-custom-height">
        <v-main>
            <template v-if="screen_loading">
                <div
                    class="d-flex flex-column align-center justify-center pa-4 ga-4"
                    style="height: 100vh"
                >
                    <div class="logo-container-wrapper animated-border-card">
                        <div class="logo-container">
                            <img :src="system_mini_logo" class="loading-logo" />
                        </div>
                    </div>
                    <span class="font-size-14 text-slate-500">Loading...</span>
                </div>
            </template>
            <template v-else>
                <v-dialog v-model="alertDialog" max-width="400">
                    <v-card>
                        <v-card-title class="card-title-custom">
                            <img
                                :src="yellowWarningIcon"
                                alt="Warning"
                                style="max-width: 32px; max-height: 32px"
                            />
                            <span>Warning!</span>
                        </v-card-title>
                        <v-card-text class="pb-3">
                            <span class="d-block text-red-accent-2">
                                CASTCORE in this browser is not officially
                                supported.
                            </span>
                            <span class="d-block font-size-14">
                                You may experience some issues. CASTCORE has
                                been designed to work best with Google Chrome
                                and other Chromium-based browsers like Microsoft
                                Edge.
                            </span>
                            <span class="d-block font-size-12 mt-4"
                                >Suggested Browsers</span
                            >
                            <div
                                class="d-flex flex-column gap-2 bg-grey-lighten-4 rounded-lg pa-2"
                            >
                                <div class="d-flex w-100 py-4">
                                    <div class="d-flex w-50">
                                        <img
                                            :src="chrome_icon"
                                            alt="Chrome"
                                            class="ma-auto"
                                            style="
                                                max-width: 64px;
                                                max-height: 64px;
                                            "
                                        />
                                    </div>
                                    <div class="d-flex w-50">
                                        <img
                                            :src="edge_icon"
                                            alt="Edge"
                                            class="ma-auto"
                                            style="
                                                max-width: 64px;
                                                max-height: 64px;
                                            "
                                        />
                                    </div>
                                </div>
                            </div>
                            <v-btn
                                class="px-4 mt-6"
                                variant="flat"
                                color="grey-darken-4"
                                text="I understand and wish to proceed"
                                @click="processAlertDialog"
                                block
                            ></v-btn>
                            <v-checkbox
                                hide-details
                                density="compact"
                                v-model="dont_show_again"
                                label="Don't show this message again"
                            ></v-checkbox>
                        </v-card-text>
                    </v-card>
                </v-dialog>

                <template v-if="showComponent === true">
                    <!-- Top Navigation Bar -->
                    <v-toolbar
                        style="height: 56px !important"
                        class="bg-white flex-column border-b"
                    >
                        <template v-slot:prepend>
                            <img
                                src="https://komt.com.my/wp-content/uploads/2024/03/General_logo-8.png"
                                alt="KOMT"
                                class="h-full py-2"
                                style="width: 120px"
                            />
                            <!-- <v-btn
                                class="text-neutral-500"
                                :icon="menuIcon"
                                @click.stop="drawer = !drawer"
                                density="compact"
                            ></v-btn> -->
                            <!-- <v-btn color="grey-lighten-1" class="d-block d-md-none" :icon="arrowLeftIcon" density="compact"
                            @click="goBack"></v-btn> -->
                            <span class="page-title-text">{{
                                currentRouteName
                            }}</span>
                        </template>

                        <v-btn
                            size="small"
                            variant="text"
                            :prepend-icon="mdiLogout"
                            @click="logout"
                            text="logout"
                        />
                    </v-toolbar>
                </template>
                <div id="set_inner_container_height">
                    <div id="page_containter">
                        <router-view
                            @settingDialog="requestSelectProject"
                            @select-project="projectShortcut"
                            :key="refreshKey"
                        />
                    </div>
                </div>
            </template>
            <!-- <v-footer class="border-t" style="height: 36px">
        <small class="text-grey"
          >© 2024 - {{ year }} CastCore Precast ERP. All rights reserved. (Ver
          0.9)</small
        >
      </v-footer> -->
        </v-main>
    </v-layout>
</template>

<script>
import {
    mdiChevronDown,
    mdiCheckBold,
    mdiHomeSwitchOutline,
    mdiBellOutline,
    mdiChevronLeft,
    mdiMenu,
    mdiLogout,
    mdiAlertCircleOutline,
    mdiChevronUp,
    mdiChevronRight,
    mdiAlertOutline,
    mdiOfficeBuildingCog,
    mdiMagnify,
    mdiSwapHorizontal,
} from "@mdi/js";

export default {
    data() {
        return {
            screen_loading: false,
            system_mini_logo: require("@/assets/system_logo/komt_mini.png"),
            chrome_icon: require("@/assets/chrome_icon.png"),
            edge_icon: require("@/assets/edge_icon.png"),
            shortcutIcon: require("@/assets/shortcut_icon1.png"),
            yellowWarningIcon: require("@/assets/yellow_warning_icon.png"),
            select_project_button_title: "Select Project",
            project_selected: false,
            project_type: null,
            refreshKey: 0,
            tab: "building",
            isMobile: false,
            showComponent: false,
            settingDialog: false,
            alertDialog: false,
            ALL_COMPANY: null,
            sidebar_loading: false,
            dont_show_again: false,
            drawer: null,
            errors: null,
            permissions: null,
            PROJECT_SHORTCUT: null,
            groupedProjects: {},
            USERNAME: localStorage.getItem("username"),
            USER_EMAIL: localStorage.getItem("email"),
            COMPANY_NAME: localStorage.getItem("current_company"),
            PROFILE_AVATAR: localStorage.getItem("profile_photo"),
            COMPANY_LOGO: localStorage.getItem("company_logo"),
            AVAILABLE_MODULES: localStorage.getItem("available_modules"),
            arrowLeftIcon: mdiChevronLeft,
            arrowRightIcon: mdiChevronRight,
            arrowUpIcon: mdiChevronUp,
            arrowDownIcon: mdiChevronDown,
            checkedIcon: mdiCheckBold,
            companyIcon: mdiHomeSwitchOutline,
            noticeIcon: mdiBellOutline,
            menuIcon: mdiMenu,
            alertIcon: mdiAlertCircleOutline,
            logoutIcon: mdiLogout,
            alertIcon2: mdiAlertOutline,
            mdiOfficeBuildingCog: mdiOfficeBuildingCog,
            searchIcon: mdiMagnify,
            mdiSwapHorizontal: mdiSwapHorizontal,
            mdiLogout,
            showSearchDialog: false,
            currentRouteName: "",
            year: new Date().getFullYear(),
        };
    },
    watch: {
        $route(to) {
            this.currentRouteName = to.name;
        },
    },
    beforeUnmount() {
        window.removeEventListener("resize", this.checkScreenSize); // Remove resize event listener when component is unmounted
        document.removeEventListener("keydown", this.handleKeydown);
    },
    async created() {
        this.screen_loading = true;
        document.title = "CastCore";
        await this.checkScreenSize();
        window.addEventListener("resize", this.checkScreenSize); // Listen for window resize events
        document.addEventListener("keydown", this.handleKeydown); // Listen for keyboard events
        const token = localStorage.getItem("token");
        if (token) {
            const user_id = localStorage.getItem("user_id");
            if (!user_id) {
                this.logout();
            }
            this.ALL_COMPANY = JSON.parse(
                localStorage.getItem("available_companies")
            );
            this.sidebar_loading = true;
            // await this.reloadAllModules();
            // await this.getProjectShortcut();
            this.sidebar_loading = false;
            console.log("All Modules Loaded");
        }
        this.showComponent = !!token;

        if (!this.showComponent) {
            const element = document.getElementById("app");
            element.style.height = "calc(100% - 36px)";
        }
        this.currentRouteName = this.$route.name;

        // Check browser type
        const browser = this.getThisBrowser();
        if (browser !== true) {
            this.alertDialog = true;
            if (localStorage.getItem("dont_show_alert_dialog")) {
                this.alertDialog = false;
            }
        }

        this.setProjectTitle();

        // if (localStorage.getItem("project")) {
        //     const selected_project = JSON.parse(
        //         localStorage.getItem("project")
        //     );
        // }

        // const selected_project = localStorage.getItem("project");
        // if (!selected_project) {
        //     this.$router.push("/general-dashboard");
        // }

        setTimeout(() => {
            this.screen_loading = false;
        }, 500);
    },
    methods: {
        processAlertDialog() {
            if (this.dont_show_again) {
                localStorage.setItem("dont_show_alert_dialog", true);
            } else {
                localStorage.setItem("dont_show_alert_dialog", false);
            }
            this.alertDialog = false;
        },
        goToHome() {
            this.$router.push({ name: "Home" });
        },
        goToProfile() {
            this.$router.push("/UserProfile");
        },
        logout() {
            // Clear local storage
            localStorage.clear();

            // Optionally, you might want to redirect the user to the login page
            // You can use Vue Router for this:
            location.reload();
        },
        async checkScreenSize() {
            this.isMobile = window.innerWidth < 768; // Set isMobile to true if screen width is less than 768 pixels
        },
        goBack() {
            this.$router.go(-1); // Go back to the previous page
        },
        projectShortcut(item, forceReload = false) {
            // const pathName = this.$route.name;
            // const fixedPathNamne = 'Project Information'
            // const newPath = `/Project/View/${id}`;

            // if (pathName !== fixedPathNamne) {
            // this.$router.push(newPath);
            // } else {
            //     // 如果路径相同，强制重新加载组件
            //     this.$router.replace({ path: '/empty', query: { redirect: newPath } })
            //         .then(() => {
            //             this.$router.push(newPath);
            //         });
            // }
            // const current_project_type = this.project_type;
            // const new_project_type = item.type;
            this.screen_loading = true;
            const project_info = {
                project_id: item.id,
                project_name: item.name,
                project_code: item.code,
                type: item.type,
            };

            localStorage.setItem("project", JSON.stringify(project_info));

            this.setProjectTitle();

            this.$router.push({ name: "Home" });

            if (forceReload) this.getProjectShortcut();

            // if (new_project_type !== current_project_type) {
            //     this.$router.push("/");
            // } else {
            //     this.refreshKey++;
            // }
            setTimeout(() => {
                this.screen_loading = false;
            }, 500);

            this.settingDialog = false;
        },
        getThisBrowser() {
            const userAgent = navigator.userAgent;

            //chrome, chromium, crios
            if (userAgent.match(/chrome|chromium|crios/i)) {
                return true;
            }

            //edge
            if (userAgent.match(/edg/i)) {
                return true;
            }

            //firefox, fxios
            if (userAgent.match(/firefox|fxios/i)) {
                return false;
            }

            //safari
            if (userAgent.match(/safari/i)) {
                return false;
            }

            //opera
            if (userAgent.match(/opr\//i)) {
                return false;
            }
            //internet explorer
            if (userAgent.match(/trident/i)) {
                return false;
            }

            return false;
        },
        handleDrawerMouseLeave() {
            this.isHoveringDrawer = false;
            this.isHoveringMenu = false;
        },
        handleMenuMouseLeave() {
            this.isHoveringMenu = false;
        },
        setProjectTitle() {
            const get_project = JSON.parse(localStorage.getItem("project"));
            if (!get_project) {
                this.project_selected = false;
                this.select_project_button_title = "Select Project";
            } else {
                this.select_project_button_title = get_project.project_code;
                this.project_selected = true;
                this.project_type = get_project.type;
            }
        },
        clearProjectShortcut() {
            localStorage.removeItem("project");
            this.select_project_button_title = "Select Project";
            this.project_type = null;
            this.project_selected = false;
            this.$router.push("/general-dashboard");
        },
        requestSelectProject() {
            this.settingDialog = true;
        },
        isModuleActive(module) {
            // Check if this module or any of its submodules is active
            if (module.submodule.length === 0) {
                return this.$route.path === module.link;
            } else {
                return module.submodule.some(
                    (sub) => this.$route.path === sub.link
                );
            }
        },
        handleKeydown(event) {
            // Check for Ctrl + K (Windows/Linux) or Cmd + K (Mac)
            if ((event.ctrlKey || event.metaKey) && event.key === "k") {
                // Don't trigger if user is typing in an input field
                const activeElement = document.activeElement;
                const isInInput =
                    activeElement &&
                    (activeElement.tagName === "INPUT" ||
                        activeElement.tagName === "TEXTAREA" ||
                        activeElement.isContentEditable);

                if (!isInInput) {
                    event.preventDefault();
                    this.openSearchDialog();
                }
            }
        },
        openSearchDialog() {
            if (this.project_selected && this.project_type) {
                this.showSearchDialog = true;
            }
        },
        onModuleSelected(result) {
            // Navigate to the selected module/submodule
            this.$router.push(result.link);

            // Store module information in localStorage if needed
            if (result.type === "submodule") {
                localStorage.setItem("module_id", result.parentId);
                localStorage.setItem("sub_module_id", result.id);
            } else {
                localStorage.setItem("module_id", result.id);
                localStorage.removeItem("sub_module_id");
            }
        },
    },
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap");

body {
    font-family: "Inter", sans-serif;
}

::-webkit-scrollbar {
    width: 8px;
    /* Width of the scrollbar */
    height: 8px;
}

::-webkit-scrollbar-thumb {
    background-color: #d1d1d1;
    /* Color of the scrollbar thumb */
    border-radius: 6px;
    /* Rounded corners */
}

::-webkit-scrollbar-track {
    background-color: white;
    /* Color of the scrollbar track */
}

body,
html {
    // background-color: #f9fafb;
    // background-color: #fafafa;
    background-color: white;
    height: 100%;
}

#app {
    //   height: calc(100% - 92px);
    height: calc(100% - 56px);
}

.grey-card {
    background-color: rgba(0, 0, 0, 0.04);
}

.set-custom-height {
    height: 100%;
}

#set_inner_container_height {
    // padding: 1.5rem;

    min-height: 100%;
    width: 100% !important;
    justify-content: center;
    display: flex;

    #page_containter {
        width: 100%;
        min-height: 100%;
        max-height: 100%;
        // max-width: 1920px;
    }
}

.v-breadcrumbs-item {
    padding: 0 !important;
}

.custom-table-block {
    padding: 1rem;
    border-radius: 0.375rem;
    background-color: white;
}

.text-type-main {
    font-size: 16px;
    font-weight: 500;
}

.text-type-sub {
    font-size: 14px;

    &-mini {
        font-size: 12px;
    }
}

.light-grey-border {
    border: 1px solid #e9ecef;
}

.bg-light-grey {
    background-color: #e9ecef;
}

.profile-avatar {
    height: 40px;
    width: 40px;
}

.swal2-container {
    z-index: 9999;
}

// ::-webkit-input-placeholder {
//     /* WebKit browsers */
//     color: transparent !important;
// }

// :-moz-placeholder {
//     /* Mozilla Firefox 4 to 18 */
//     color: transparent !important;
// }

// ::-moz-placeholder {
//     /* Mozilla Firefox 19+ */
//     color: transparent !important;
// }

// :-ms-input-placeholder {
//     /* Internet Explorer 10+ */
//     color: transparent !important;
// }

// input::placeholder {
//     color: transparent !important;
// }

// textarea::-webkit-input-placeholder {
//     /* WebKit browsers */
//     color: transparent !important;
// }

// textarea:-moz-placeholder {
//     /* Mozilla Firefox 4 to 18 */
//     color: transparent !important;
// }

// textarea::-moz-placeholder {
//     /* Mozilla Firefox 19+ */
//     color: transparent !important;
// }

// textarea:-ms-input-placeholder {
//     /* Internet Explorer 10+ */
//     color: transparent !important;
// }

// textarea::placeholder {
//     color: transparent !important;
// }

.swal2-confirm.swal2-styled,
.swal2-cancel.swal2-styled,
.swal2-confirm.swal2-styled.swal2-default-outline {
    color: white !important;
}

.swal2-html-container ul {
    list-style-type: none;
}

.dp__pointer.dp__input.dp__input_icon_pad.dp__input_reg {
    border: 1px solid #bdbdbd;
}

.dp__pointer.dp__input.dp__input_icon_pad.dp__input_reg:hover {
    border: 1px solid black;
}

.dp__disabled.dp__input_readonly.dp__input.dp__input_icon_pad.dp__input_reg:hover,
.dp__disabled.dp__input_readonly.dp__input.dp__input_icon_pad.dp__input_reg:disabled {
    border: 1px solid #e0e0e0;
    color: #bdbdbd;
    background-color: white;
}

.sidebar-custom-shadow {
    box-shadow: rgba(0, 0, 0, 0.1) 0px 10px 15px -3px,
        rgba(0, 0, 0, 0.05) 0px 4px 6px -2px;

    .v-list-group__items {
        background-color: #f9f9f9;
        border-radius: 0.375rem;
        padding-top: 0.5rem;
        padding-bottom: 0.5rem;
    }

    .v-navigation-drawer__content {
        transition: width 0.2s ease-out;

        /* 添加以下代码来隐藏滚动条 */
        &::-webkit-scrollbar {
            display: none;
        }

        -ms-overflow-style: none;
        /* IE and Edge */
        scrollbar-width: none;
        /* Firefox */
    }
}

.v-navigation-drawer--rail {
    .v-list-item {
        .v-list-item-title {
            opacity: 0;
            transition: opacity 0.1s ease-out;
        }
    }
}

.v-navigation-drawer--expand-on-hover:hover {
    .v-list-item {
        .v-list-item-title {
            opacity: 1;
            transition: opacity 0.2s ease-in;
        }
    }
}

.mobile-only {
    display: none;
}

.submodule-container {
    overflow: hidden;
    max-height: 0;
    transition: max-height 0.2s ease-out;

    &.active {
        max-height: 1000px; // 设置一个足够大的值
        transition: max-height 0.4s ease-in;
    }

    .submodule-content {
        border-radius: 0.375rem;
        background-color: #f9f9f9;
        padding: 0.5rem 0;
    }
}

.module-arrow {
    transition: transform 0.2s ease;
    transform: rotate(0deg);

    &.active {
        transform: rotate(90deg);
    }
}

.active-module,
.active-submodule {
    color: #2979ff;
    background-color: #dfe9f9;
}

.custom-selector-item-with-dropdown {
    height: 32px;
    min-width: 200px;
    width: 200px;
    background-color: white;
    border-radius: 6px;
    //   border-radius: 6px;
    border: 1px solid var(--border-color);
    //   --my-shadow: 0px 0px 0px 1px rgba(9, 9, 11, 0.07),
    //     0px 2px 2px 0px rgba(9, 9, 11, 0.05);
    //   --my-shadow-colored: 0px 0px 0px 1px var(--my-shadow-color),
    //     0px 2px 2px 0px var(--my-shadow-color);
    //   box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000),
    //     var(--tw-ring-shadow, 0 0 #0000), var(--my-shadow);

    .dropdown-icon {
        margin-left: auto;
    }
}

.custom-input-wrapper,
.custom-search-bar {
    width: 200px;

    &.long-type {
        width: 350px;

        .v-field__append-inner {
            padding-top: 0;
            align-items: center;
        }
    }
}

.mobile-material-btn {
    position: fixed;
    bottom: 16px;
    right: 16px;
    z-index: 1;
}

.sw-custom-border {
    height: 100%;
    --my-shadow: 0px 0px 0px 1px rgba(9, 9, 11, 0.07),
        0px 2px 2px 0px rgba(9, 9, 11, 0.05);
    --my-shadow-colored: 0px 0px 0px 1px var(--my-shadow-color),
        0px 2px 2px 0px var(--my-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000),
        var(--tw-ring-shadow, 0 0 #0000), var(--my-shadow);
}

.card-title-custom {
    display: flex;
    padding-top: 1rem;
    gap: 0.5rem;
    align-items: center;
    padding-left: 1.5rem;
}

@media only screen and (max-width: 767.5px) {
    .custom-input-wrapper,
    .custom-search-bar {
        width: 100%;

        &.long-type {
            width: 100%;
        }
    }

    .custom-selector-item-with-dropdown {
        min-width: 100%;
        width: 100%;
    }

    .mobile-only {
        display: flex;
    }

    .desktop-only {
        display: none;
    }
}

.v-toolbar__content {
    height: 56px !important;
    padding: 0 1rem;
}

.title-control {
    display: none !important;
}

/* Tailwind-inspired sidebar styles */
.tailwind-sidebar {
    background-color: #ffffff;
    border-right: 1px solid #e5e7eb;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);

    .sidebar-header {
        background-color: #ffffff;
        border-bottom: 1px solid #f3f4f6;
    }

    .sidebar-content {
        background-color: #ffffff;
        height: calc(100vh - 70px);
        overflow-y: auto;
        scrollbar-width: thin;
        scrollbar-color: #cbd5e1 transparent;

        &::-webkit-scrollbar {
            width: 4px;
        }

        &::-webkit-scrollbar-track {
            background: transparent;
        }

        &::-webkit-scrollbar-thumb {
            background-color: #cbd5e1;
            border-radius: 4px;
        }

        &::-webkit-scrollbar-thumb:hover {
            background-color: #94a3b8;
        }
    }

    .nav-group {
        margin-bottom: 0.25rem;
    }

    .sub-nav-link-wrapper {
        border-left: 1px solid var(--slate-300);

        &.active-sub-nav-link-wrapper {
            border-left: 1px solid var(--neutral-900);
        }
    }

    .nav-link,
    .sub-nav-link {
        margin-left: 0.25rem;
        padding: 0.375rem 0.625rem;
        // border-left: 1px solid var(--slate-300);
        border-radius: 0.25rem;
        text-decoration: none;
        color: var(--slate-500);

        &:hover {
            text-decoration: none;
            background-color: var(--slate-100);
            color: var(--neutral-900);
        }

        &.router-link-active {
            color: var(--neutral-900);
            // background-color: #eff6ff;
            // color: #1d4ed8;
            // border-right: 2px solid #1d4ed8;
            font-weight: 500;
        }
    }

    .group-toggle {
        background: none;
        border: none;
        cursor: pointer;
        outline: none;

        &:focus {
            outline: 2px solid #3b82f6;
            outline-offset: 2px;
        }
    }

    .submodule-list {
        animation: slideDown 0.2s ease-out;
    }

    /* Utility classes */
    .space-y-1 > * + * {
        margin-top: 0.25rem;
    }

    .space-y-3 > * + * {
        margin-top: 0.75rem;
    }

    .space-y-4 > * + * {
        margin-top: 1rem;
    }

    .space-x-3 > * + * {
        margin-left: 0.75rem;
    }

    .flex {
        display: flex;
    }

    .flex-1 {
        flex: 1 1 0%;
    }

    .flex-shrink-0 {
        flex-shrink: 0;
    }

    .items-center {
        align-items: center;
    }

    .justify-between {
        justify-content: space-between;
    }

    .block {
        display: block;
    }

    .w-full {
        width: 100%;
    }

    .h-full {
        height: 100%;
    }

    .w-10 {
        width: 2.5rem;
    }

    .h-10 {
        height: 2.5rem;
    }

    .w-3\/4 {
        width: 75%;
    }

    .w-1\/2 {
        width: 50%;
    }

    .h-3 {
        height: 0.75rem;
    }

    .h-2 {
        height: 0.5rem;
    }

    .h-8 {
        height: 2rem;
    }

    .p-6 {
        padding: 1.5rem;
    }

    .px-3 {
        padding-left: 0.75rem;
        padding-right: 0.75rem;
    }

    .py-2 {
        padding-top: 0.5rem;
        padding-bottom: 0.5rem;
    }

    .py-4 {
        padding-top: 1rem;
        padding-bottom: 1rem;
    }

    .pl-9 {
        padding-left: 2.25rem;
    }

    .mr-3 {
        margin-right: 0.75rem;
    }

    .mt-1 {
        margin-top: 0.25rem;
    }

    .mb-6 {
        margin-bottom: 1.5rem;
    }

    .mb-8 {
        margin-bottom: 2rem;
    }

    .mb-3 {
        margin-bottom: 0.75rem;
    }

    .mb-1 {
        margin-bottom: 0.25rem;
    }

    .ml-6 {
        margin-left: 1.5rem;
    }

    .min-w-0 {
        min-width: 0;
    }

    .w-0\.5 {
        width: 0.125rem;
    }

    .w-1\/3 {
        width: 33.333333%;
    }

    .w-1\/2 {
        width: 50%;
    }

    .h-6 {
        height: 1.5rem;
    }

    .top-0 {
        top: 0;
    }

    .bottom-0 {
        bottom: 0;
    }

    .left-0 {
        left: 0;
    }

    .relative {
        position: relative;
    }

    .absolute {
        position: absolute;
    }

    .font-semibold {
        font-weight: 600;
    }

    .uppercase {
        text-transform: uppercase;
    }

    .tracking-wider {
        letter-spacing: 0.05em;
    }

    .text-gray-700 {
        color: #374151;
    }

    .text-blue-600 {
        color: #2563eb;
    }

    .bg-blue-600 {
        background-color: #2563eb;
    }

    .space-y-6 > * + * {
        margin-top: 1.5rem;
    }

    .overflow-hidden {
        overflow: hidden;
    }

    .overflow-y-auto {
        overflow-y: auto;
    }

    .truncate {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .rounded-full {
        border-radius: 9999px;
    }

    .rounded-md {
        border-radius: 0.375rem;
    }

    .rounded {
        border-radius: 0.25rem;
    }

    .border-b {
        border-bottom-width: 1px;
    }

    .border-r-2 {
        border-right-width: 2px;
    }

    .border-gray-200 {
        border-color: #e5e7eb;
    }

    .border-blue-700 {
        border-color: #1d4ed8;
    }

    .bg-blue-500 {
        background-color: #3b82f6;
    }

    .bg-blue-50 {
        background-color: #eff6ff;
    }

    .bg-gray-50 {
        background-color: #f9fafb;
    }

    .bg-red-50 {
        background-color: #fee2e2;
    }

    .bg-gray-200 {
        background-color: #e5e7eb;
    }

    .object-cover {
        object-fit: cover;
    }

    .text-xs {
        font-size: 0.75rem;
        line-height: 1rem;
    }

    .text-sm {
        font-size: 0.875rem;
        line-height: 1.25rem;
    }

    .font-medium {
        font-weight: 500;
    }

    .text-gray-900 {
        color: #111827;
    }

    .text-gray-600 {
        color: #4b5563;
    }

    .text-gray-500 {
        color: #6b7280;
    }

    .text-gray-400 {
        color: #9ca3af;
    }

    .text-blue-700 {
        color: #1d4ed8;
    }

    .text-blue-500 {
        color: #3b82f6;
    }

    .text-red-500 {
        color: #ef4444;
    }

    .text-white {
        color: #ffffff;
    }

    .transition-colors {
        transition-property: color, background-color, border-color,
            text-decoration-color, fill, stroke;
        transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    }

    .transition-transform {
        transition-property: transform;
        transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    }

    .duration-150 {
        transition-duration: 150ms;
    }

    .rotate-90 {
        transform: rotate(90deg);
    }

    .animate-pulse {
        animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
    }

    .group:hover .group-hover\:text-gray-500 {
        color: #6b7280;
    }

    .hover\:bg-gray-50:hover {
        background-color: #f9fafb;
    }

    .hover\:text-gray-900:hover {
        color: #111827;
    }

    .hover\:bg-red-50:hover {
        background-color: #fee2e2;
    }
}

.hover\:text-neutral-900:hover {
    color: var(--neutral-900);
}

.hover\:text-red-500:hover {
    color: #ef4444;
}

@keyframes pulse {
    0%,
    100% {
        opacity: 1;
    }
    50% {
        opacity: 0.5;
    }
}

@keyframes slideDown {
    from {
        opacity: 0;
        transform: translateY(-10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

#menu-activator {
    border-radius: 9999px;
    border: 1px solid var(--slate-100);
    padding: 0.25rem;
    width: 44px;
    height: 44px;
    cursor: pointer;

    &:hover {
        border-color: var(--slate-300);
    }

    img {
        border-radius: 9999px;
        height: 100%;
        width: 100%;
        object-fit: cover;
    }
}

.logo-container {
    position: relative;
    height: 100px;
    width: 100px;
    display: flex;
    padding: 0.5rem;
    margin: 0 auto;
    //   background: #1c1f2b;
    background: #ffffff;
    text-align: center;
    border-radius: 10px;
    z-index: 1;

    .loading-logo {
        object-fit: contain;
        height: 100%;
        width: 100%;
    }
}

@property --angle {
    syntax: "<angle>";
    initial-value: 0deg;
    inherits: false;
}

/* 旋转边框卡片动画效果 */
.animated-border-card {
    position: relative;
    // background: #23243a;
    color: #fff;
    border-radius: 14px;
    padding: 1rem;
    text-align: center;
    overflow: hidden;
    margin: 0 auto;
    // box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
}

.animated-border-card::before {
    --angle: 0deg;
    content: "";
    position: absolute;
    height: 100%;
    width: 100%;
    inset: -4px;
    border-radius: 10px;
    background: conic-gradient(
        from var(--angle),
        #006aff,
        #0000ff,
        #00d4ff,
        #00ffb2,
        #00ff7f
    );
    transform: translate(-50%, -50%);
    top: 50%;
    left: 50%;
    padding: 3px;
    // z-index: -1;
    animation: spin 3s linear infinite;
}

.animated-border-card::after {
    content: "";
    position: absolute;
    inset: 4px;
    border-radius: 10px;
    // background: #23243a;
    background: #ffffff;
    // z-index: -1;
}

.animated-border-card::before {
    filter: blur(1rem);
    // opacity: 0.5;
}

@keyframes spin {
    from {
        --angle: 0deg;
    }
    to {
        --angle: 360deg;
    }
}

// @keyframes rotateBorder {
//   0% {
//     transform: rotate(0deg);
//   }
//   100% {
//     transform: rotate(360deg);
//   }
// }

.animated-border-card .logo-container {
    background: transparent;
    box-shadow: none;
    position: relative;
    z-index: 1;
}

.animated-border-card .logo-container-wrapper {
    position: relative;
    z-index: 1;
}

.animated-border-card span {
    position: relative;
    z-index: 1;
    color: rgba(255, 255, 255, 0.8);
}
</style>
